import React from 'react';
import { colorPalette } from '../../data/colors';
import { clsx } from 'clsx';
import { FaCheck } from 'react-icons/fa';

const ColorPalette = ({ selectedColor, onColorSelect }) => {
  return (
    <div className="grid grid-cols-6 gap-2">
      {colorPalette.map((color) => {
        const isSelected = selectedColor === color.hex;
        return (
          <button
            key={color.id}
            onClick={() => onColorSelect(color.hex)}
            className={clsx(
              "w-8 h-8 rounded-full shadow-sm border border-slate-200 relative flex items-center justify-center transition-transform hover:scale-110",
              isSelected && "ring-2 ring-offset-2 ring-slate-900 z-10 scale-110"
            )}
            style={{ backgroundColor: color.hex }}
            title={color.name}
            aria-label={`Select color ${color.name}`}
          >
            {isSelected && <FaCheck className={clsx("text-xs", color.id === 'white' || color.id === 'cream' ? "text-slate-900" : "text-white")} />}
          </button>
        );
      })}
    </div>
  );
};

export default ColorPalette;